<template>
  <div>
    <div id="ConsultaDireccion_div" class="">
      <div id="TituloConsultaDireccion_div" class="w-100">
        <h1 style="margin-bottom: 0px;">Consulta pública de cédulas</h1>
        <!-- <h3 style="margin-top: 0px;">Ingrese la infromación requerida para la búsqueda</h3> -->
      </div>
      <div id="encabezado-contenedor-contenido" class="form-inline mt-3">
        <div class="flex-grow-1 pl-3"><h4>Información de notificaciones de expedientes autorizados</h4></div>
      </div>
      <div id="contenedor-principal" class="area">
        <!-- <h3>Ingrese la información requerida para buscar y filtrar las cédulas</h3> -->
        <div id="ContenidoConsultaDireccion_div" class=" mt-1 mb-2">
        <div>
          <div class="contenedor-color-negro">
            <FiltrosDeBusqueda 
              :catalogos="catalogos" 
              :posicionHorizontal="true"
              :ejecutaLaFuncion="evtBuscarCedulas" 
              :filtrosEstablecidos="filtrosEstablecidos" 
              :elementosAOmitir ="elementosAOmitir"
              :tituloDeBusqueda="'Paso 1: Busca las cédulas'"
              :ref="REF_FB"></FiltrosDeBusqueda>
          </div>
        </div>
         <div style="margin-top:3em;">
            <div v-show="!cargandoCedulas" id="PanelDeAudienciasPendientesPendientes_table">
              <div style="background-color:black; padding: 8px;">
                <div class="d-flex justify-content-center">
                  <i class="fas fa-clipboard-list mr-sm-2" style="font-size: 25px;"></i>
                  <div class="align-content-center">
                    <h5>Mis Cédulas</h5>
                  </div>
                </div>
              </div>
              <div class="contenedor-color-negro mb-4">
                <div>
                  <div id="filtros-memoria-cedulas-vccp" class="form-inline mb-3 justify-content-end">
                    <div id="filtros-input-cedulas-memoria" class="f-item form-group mr-sm-2">
                      <h6 for="f-busqueda" class="mr-sm-2">Buscar:</h6>
                      <input v-model="f_busqueda" type="text" id="f-busqueda" placeholder="Buscar en todas las columnas" class="form-control" style="width: 300px;"/>
                    </div>
                    <div class="f-item form-group">
                      <button type="button" id="btn-limpiar-filtro" @click="evtResetearFiltros" class="btn-sm btn-primary"><i class="fas fa-undo"></i></button>
                    </div>
                  </div>
                  <TablaGenericaCedulas class="table-responsive"
                    :idDelInput="idTabla" 
                    :encabezadosColumnas="encabezadosColumnas" 
                    :accionesEnTabla="tablaAcciones" 
                    :listaDeCedulas="cedulasTablaConFiltros"                     
                    v-on:accionFuncionDetalles="evtDetallesCedula"
                    :conResponsive="true"
                    :ref="REF_T_CEDULAS"></TablaGenericaCedulas>
                </div>
              </div>
            </div>
            <div v-show="cargandoCedulas" class="contenedor-cargando" style="height: 300px ;">
              <div class="text-center">
                  <i class="fas fa-spinner fa-spin fa-5x"></i>
                  <h4 class="mt-4">Cargando cedulas</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import sistemas from '@/../static/js/sistemas'
  import comun from "@/../static/js/comun"
  import api from '@/../static/js/api'
  import axios from 'axios'
  import router from '@/router/index'
  import VueMask from 'v-mask'
  import { mapActions } from 'vuex'

  export default {
   components: {
      FiltrosDeBusqueda: sistemas.SINOJ.FiltrosDeBusqueda,
      TablaGenericaCedulas: sistemas.SINOJ.CTablaGenericaCedulas
    },
    data() {
      return {
        enumeraciones,
        catalogos: [
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_PartidoJudicial_ConsultaPublica' },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Materia_ConsultaPublica' },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Area_ConsultaPublica' },
          { catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_TipoDocumento_ConsultaPublica' },
          { catalogoId: enumeraciones.catalogos.Consecutivo, idDelInput: 'filtroDeBusqueda_Consecutivo_ConsultaPublica' },
          { catalogoId: enumeraciones.catalogos.NumeroExtra, idDelInput: 'filtroDeBusqueda_NumeroExtra_ConsultaPublica' }         
        ],
        filtrosEstablecidos: {},
        REF_T_CEDULAS: 'REFtablaConsultasVCP',
        REF_FB: 'REFFiltrosBVCP',
        idTabla: 'tablaCedulasDireccion',
        encabezadosColumnas: ['Folio', 'Tipo de documento', 'Consecutivo', 'Tipo de cédula', 'Estatus', 'Resultado', ''],
        tablaAcciones: { motrarAcciones: true, check: false, eliminar: false, detalles: true },
        listaDeCedulas: [
          { Folio: 12321, tipoDeDocumento: 'Expediente Principal', consecutivo: '0001/2020', tipoDeCedula: '001', estatus: 'Realizada', resultado: 'Razonada' },
          { Folio: 12321, tipoDeDocumento: 'Expediente Principal', consecutivo: '0001/2020', tipoDeCedula: '001', estatus: 'Realizada', resultado: 'Razonada' },
          { Folio: 12321, tipoDeDocumento: 'Expediente Principal', consecutivo: '0001/2020', tipoDeCedula: '001', estatus: 'Realizada', resultado: 'Razonada' },
          { Folio: 12321, tipoDeDocumento: 'Expediente Principal', consecutivo: '0001/2020', tipoDeCedula: '001', estatus: 'Realizada', resultado: 'Razonada' },
          { Folio: 12321, tipoDeDocumento: 'Expediente Principal', consecutivo: '0001/2020', tipoDeCedula: '001', estatus: 'Realizada', resultado: 'Razonada' },
        ],
        cargandoCedulas: false,
        f_busqueda : null,
        cedulasBD: [],
        cedulasTabla: [],
        cedulasTablaConFiltros: [],
        FILTROS_CARGADOS_PREVIAMENTE: null,
        contadorRenderFiltros: 0,
        FILTROS_BUSQUEDA: null,
        elementosAOmitir: {
          areas: [11,12,13,14,15,16,95] //áreas de Majat
        }
      }
    },
    methods: {
      /* cargaCedulas: function () {
        console.log("Se obtienen cédulas");
      },
      detallesCedulaAsignada: function (evento) {
        let id = evento.target.getAttribute('id');
        let folioCedula = id.split('-')[id.split('-').length - 1];
        router.push({ name: "DetallesConsultaPublica", params: { FolioCedula: folioCedula } })
      }, */
      filtrarCedulasTabla: function(e) {
        // filtra por columnas y nivel de prioridad
        this.cedulasTablaConFiltros = this.cedulasTabla
        .filter(c => {
          return Object.values(c).some(valorColumna => this.predicateFiltradoPorSimilitud(valorColumna, this.f_busqueda));
        });
      },
      predicateFiltradoPorSimilitud: function(elementoAEvaluar,compararCon) { 
        if(this.campoRequeridoEsValido(compararCon)) {
          if(elementoAEvaluar.toString().toUpperCase().startsWith(compararCon.toString().toUpperCase()))
            return true;
          else
            return false;
        }
        else
            return true;
      },
      limpiarFiltrosDeTabla: function() {
        this.f_busqueda = null;
      },
      evtResetearFiltros: function() {
        this.limpiarFiltrosDeTabla();
        this.cedulasTablaConFiltros = this.cedulasTabla;
      },
      obtenerCedulaSeleccionado: function(evento) {
        let cedula = null;
        const CEDULA_SELECCIONADA = evento.target.getAttribute('id');
        const ID_CEDULA = parseInt(this.obtenerCedula(CEDULA_SELECCIONADA));
        cedula = this.cedulasBD.find(cDB => cDB.CedulaId == ID_CEDULA);
        return cedula;
      },
      obtenerCedula: function(cedulaSeleccionada) {
        const CEDULA = cedulaSeleccionada.split('-');
        const POSICION_ID = (CEDULA.length - 1);
        const ID_CEDULA = CEDULA[POSICION_ID];
        return ID_CEDULA;
      },
      evtDetallesCedula: function(evento) {
        let cedulaSeleccionada = this.obtenerCedulaSeleccionado(evento);
        router.push({ name: "DetallesConsultaPublica", params: { folio: cedulaSeleccionada.CedulaId, cedula: cedulaSeleccionada, filtrosPrevios: this.FILTROS_BUSQUEDA } });
      },
      evtBuscarCedulas: function () {
        this.limpiarFiltrosDeTabla();
        $("#filtros-input-cedulas-memoria input").off("change paste keyup");
        this.cedulasTablaConFiltros = [];
        this.obtenerCedulasBD();
      },
      obtenerCedulasBD: function() { 
        const SERVIDOR = api.conexion;
        const METODO_API_OBTENER = api.SINOJ.sistema.consultas.consultaPublica.ObtenerCedulasConsultaPublica;
        let urlApi = SERVIDOR + METODO_API_OBTENER;
        let peticionArchivos = false;
        let peticionAPI = {
            PartidoJudicialId: this.campoRequeridoEsValido(this.$refs[this.REF_FB].parametros_PartidoJudicial.partidoJudicialId) ? this.$refs[this.REF_FB].parametros_PartidoJudicial.partidoJudicialId : null,
            MateriaId: this.campoRequeridoEsValido(this.$refs[this.REF_FB].parametros_Materia.materiaId) ? this.$refs[this.REF_FB].parametros_Materia.materiaId : null,
            JuzgadoId: this.campoRequeridoEsValido(this.$refs[this.REF_FB].parametros_Area.areaId) ? this.$refs[this.REF_FB].parametros_Area.areaId : null,
            TipoDeDocumentoId: this.campoRequeridoEsValido(this.$refs[this.REF_FB].parametros_TipoDocumento.tipoDocumentoId) ? this.$refs[this.REF_FB].parametros_TipoDocumento.tipoDocumentoId : null,
            Consecutivo: this.campoRequeridoEsValido(parseInt(this.$refs[this.REF_FB].numeroExtra)) ? parseInt(this.$refs[this.REF_FB].numeroExtra) : null,
            NumeroDeDocumento: this.campoRequeridoEsValido(this.$refs[this.REF_FB].consecutivo) ? this.$refs[this.REF_FB].consecutivo : null,
            esPrueba: false
        }
        
        if(peticionAPI.JuzgadoId == enumeraciones.pj.areas.JuzgadoDeEjecucionDePenasYMedidasDeSeguridad)
        {
          peticionAPI.NumeroRomano = this.$refs[this.REF_FB].numeroRomano;
        }

        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
        this.cargandoCedulas = true;
        comun.SeEstaCargandoInformacion(true);
        axios.post(urlApi, peticionAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        let mensajeError = respuesta.data.Error.Mensaje;
                        console.log(mensajeError);
                        comun.mensajeDeAlerta(mensajeError, null, null);
                    } 
                    else {
                      //console.log('data::',respuesta.data.Cedulas)
                        this.cedulasBD = (respuesta.data.Cedulas != null) ? respuesta.data.Cedulas : [];
                        this.cedulasTabla = this.darFormatoCedulasTabla(this.cedulasBD);
                        $("#filtros-input-cedulas-memoria input").on("change paste keyup", (e) => {
                            if(this.cedulasTabla.length > 0 && !this.cargandoCedulas) {
                                this.filtrarCedulasTabla(e);
                            }
                        }); 
                        this.cedulasTablaConFiltros = this.cedulasTabla;
                    }
                    this.cargandoCedulas = false;
                    this.obtenerFiltrosDeBusquedaCargados();
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                    this.cargandoCedulas = false;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                }
        ); 
      },
      darFormatoCedulasTabla: function(cedulas) {
          let cedulasConFormato = [];
          cedulas.forEach(c => {
            let cedulaFormatoTabla = this.cedulaAObjetoTabla(c);
            cedulasConFormato.push(cedulaFormatoTabla);
          });
          return cedulasConFormato;
      },
      cedulaAObjetoTabla: function(cedula) { 
          // 'Folio', 'Tipo de documento', 'Consecutivo', 'Tipo de cedula', 'Estatus', 'Resultado', ''    
          let cedulaObjTabla = {};
          cedulaObjTabla.Folio = cedula.CedulaId;
          cedulaObjTabla.TipoDocumento = 'Sin documento';
          cedulaObjTabla.Consecutivo = 'Sin consecutivo';
          if(this.campoRequeridoEsValido(cedula.Expediente)) { 
            cedulaObjTabla.TipoDocumento = (cedula.Expediente.TipoDocumento != null) ? cedula.Expediente.TipoDocumento.Nombre : 'Sin documento';
            cedulaObjTabla.Consecutivo = cedula.Expediente.NumeroDeDocumento;
          }
          cedulaObjTabla.TipoCedula = this.campoRequeridoEsValido(cedula.TipoCedula.Nombre) ? cedula.TipoCedula.Nombre.trim() : 'Sin tipo de cedula.';
          cedulaObjTabla.Estatus = cedula.Estatus.Nombre;
          cedulaObjTabla.Resultado = (cedula.Resultado != null) ? cedula.Resultado.TipoResultado.Nombre : 'Sin resultado';
          return cedulaObjTabla;
      },
      obtenerFiltrosDeBusquedaCargados: function() {
        this.FILTROS_BUSQUEDA = {
            PartidoJudicialId: this.$refs[this.REF_FB].parametros_PartidoJudicial.partidoJudicialId,
            MateriaId: this.$refs[this.REF_FB].parametros_Materia.materiaId,
            JuzgadoId: this.$refs[this.REF_FB].parametros_Area.areaId,
            TipoDeDocumentoId: this.$refs[this.REF_FB].parametros_TipoDocumento.tipoDocumentoId,
            Consecutivo: this.$refs[this.REF_FB].numeroExtra,
            NumeroDeDocumento: this.$refs[this.REF_FB].consecutivo
        }
      },
      campoRequeridoEsValido: function(campo) { 
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      }
    },
    mounted() {
      if(this.FILTROS_CARGADOS_PREVIAMENTE != null && this.FILTROS_CARGADOS_PREVIAMENTE != undefined) {
        // renderizar catalogos de componente hijo filtrosDeBusqueda con valor elegido previamente
        if(this.FILTROS_CARGADOS_PREVIAMENTE.cargarConFiltros) {
          // se asignan los valores de los filtros 
            this.$refs[this.REF_FB].parametros_PartidoJudicial.partidoJudicialId = this.FILTROS_CARGADOS_PREVIAMENTE.PartidoJudicialId;
            this.$refs[this.REF_FB].parametros_Materia.materiaId = this.FILTROS_CARGADOS_PREVIAMENTE.MateriaId;
            this.$refs[this.REF_FB].parametros_Area.areaId = this.FILTROS_CARGADOS_PREVIAMENTE.JuzgadoId;
            this.$refs[this.REF_FB].parametros_TipoDocumento.tipoDocumentoId = this.FILTROS_CARGADOS_PREVIAMENTE.TipoDeDocumentoId;
            if(this.FILTROS_CARGADOS_PREVIAMENTE.TipoDeDocumentoId == enumeraciones.pj.tiposDocumento.Terceria || this.FILTROS_CARGADOS_PREVIAMENTE.TipoDeDocumentoId == enumeraciones.pj.tiposDocumento.Incidente) {
              this.$refs[this.REF_FB].numeroExtra = this.FILTROS_CARGADOS_PREVIAMENTE.Consecutivo;
              this.$refs[this.REF_FB].mostrarNumeroExtra = true;
            }
            this.$refs[this.REF_FB].consecutivo = this.FILTROS_CARGADOS_PREVIAMENTE.NumeroDeDocumento;

            // se actualizan los catalogos
            this.$refs[this.REF_FB].parametros_PartidoJudicial.key = 'CFPRJVCP' + this.contadorRenderFiltros;
            this.$refs[this.REF_FB].parametros_Materia.key = 'CFMTVCP' + this.contadorRenderFiltros;
            this.$refs[this.REF_FB].parametros_Area.key = 'CFJZVCP' + this.contadorRenderFiltros;
            this.$refs[this.REF_FB].parametros_TipoDocumento.key = 'CFTDVCP' + this.contadorRenderFiltros;
            this.contadorRenderFiltros += 1;
        }
        this.obtenerCedulasBD();
      }
    },
    created() {
      //console.log('props::',router.history.current.params);
      this.FILTROS_CARGADOS_PREVIAMENTE = router.history.current.params.filtrosParaCargar;
    }
  }
</script>
<style scoped>
.contenedor-color-negro {
  padding: 1.5em;
  background-color: #2c2d31;
  box-shadow: 0px 6px 10px 3px #161616;
}

.contenedor-cargando {
  background-color: rgb(36, 34, 34);
  height: 40px;
  height: 21rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

#filtros-memoria-cedulas-vccp .btn-sm {
  cursor: pointer;
  background-color: rgb(27, 25, 25);
  padding: 5px 15px 5px 15px;
} 

#filtros-memoria-cedulas-vccp .btn-sm:hover, #filtros-memoria-cedulas-vccp .btn-sm:focus {
  background-color: black;
}

#encabezado-contenedor-contenido {
  background-color: rgb(44, 43, 43);
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Consultas/ConsultaPublica/ConsultaPublica.vue